/* import __COLOCATED_TEMPLATE__ from './basic-page-wrapper.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();